import React, { FunctionComponent, ComponentProps } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import styles from './ButtonsContainer.module.css';

export enum ButtonsContainerAlignment {
  Right = 'right',
  Left = 'left'
}

export type ButtonsContainerProps = ComponentProps<'div'> & {
  alignment?: ButtonsContainerAlignment;
};

/**
 * A simple container which is meant to hold multiple buttons. It ensures correct spacings between multiple buttons
 */
export const ButtonsContainer: FunctionComponent<ButtonsContainerProps> =
  React.memo((props) => {
    const {
      children,
      className,
      alignment = ButtonsContainerAlignment.Left,
      ...remainingProps
    } = prepareProps({ props });

    return (
      <div
        {...remainingProps}
        className={classes(
          className,
          styles.container,
          alignmentToClassName[alignment]
        )}
      >
        {children}
      </div>
    );
  });

const alignmentToClassName: Record<ButtonsContainerAlignment, string | null> = {
  [ButtonsContainerAlignment.Left]: null,
  [ButtonsContainerAlignment.Right]: styles.alignRight
};
